var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.629 9.84071L11.8905 23.4268C9.61408 25.6781 5.923 25.6781 3.64659 23.4268C1.37018 21.1764 1.37018 17.5269 3.64659 15.2755L16.012 3.0472C17.5289 1.54664 19.9896 1.54664 21.5075 3.0472C23.0245 4.54776 23.0245 6.98145 21.5075 8.48105L9.14218 20.7094C8.3837 21.4601 7.15334 21.4601 6.3939 20.7094C5.63542 19.9596 5.63542 18.7427 6.3939 17.992L17.3861 7.12331L16.012 5.7646L5.02071 16.6342C3.50279 18.1338 3.50279 20.5675 5.02071 22.069C6.53768 23.5686 8.99841 23.5687 10.5163 22.0681L22.8807 9.84071C25.1571 7.59036 25.1581 3.93884 22.8817 1.68849C20.6043 -0.56283 16.9142 -0.56283 14.6378 1.68849L1.58536 14.5952L1.63362 14.6425C-0.73832 17.6571 -0.52893 22.015 2.27243 24.7855C5.07476 27.556 9.4809 27.7635 12.5293 25.4176L12.5766 25.4648L27.0032 11.1994L25.629 9.84071Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentChat);
export default __webpack_public_path__ + "static/media/attachment-chat.c7c2e46c4b0391ee9ef5855f1ed62413.svg";
export { ForwardRef as ReactComponent };